import {Typography} from '@pixel-party/Typography/v2';
import type React from 'react';
import {Trans} from 'react-i18next';
import {PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL} from '@/app/forms/constants';

interface TermsAndConditionsProps {
  htmlFor: string;
}

export function TermsAndConditions({
  htmlFor,
}: TermsAndConditionsProps): React.JSX.Element {
  return (
    <Typography
      use="body2"
      tag="label"
      htmlFor={htmlFor}
    >
      <Trans
        i18nKey="forms.shared.termsAndConditions"
        components={[
          <a
            key="0"
            href={TERMS_OF_SERVICE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>,
          <a
            key="1"
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>,
        ]}
      />
    </Typography>
  );
}
